import CustomPaper from './CustomPaper';
export default CustomPaper;
